import React from "react";
import { Button } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import { useNavigate } from "react-router";
import { useScopeParams } from "@/hooks/useScopeParams";

interface SuccessScreenProps {
  isAlertCreated: boolean;
  onAddAlert: () => void;
  onExit: () => void;
}

export default function SuccessScreen({
  isAlertCreated,
  onAddAlert,
  onExit,
}: SuccessScreenProps) {
  const navigate = useNavigate();
  const { buildUrl } = useScopeParams();
  const guide = isAlertCreated
    ? "wiki/guides/alerts-enhanced"
    : "wiki/guides/insights-enhanced";
  return (
    <div className="flex flex-col justify-between h-full">
      {/* Success instructions section*/}
      <div className="p-4 text-sm text-[#2B4752]">
        {!isAlertCreated && (
          <>
            <p className="font-medium mb-2">
              Your insight was created successfully!
            </p>

            <p className="mb-2">
              You can view your new insight in the Insights dashboard.
            </p>
            <p className="mb-2">
              You can also add an alert to this insight to be notified if it
              meets a custom rule.
            </p>
          </>
        )}

        {isAlertCreated && (
          <p className="mb-2">
            You can now view your new insight and alert from the Insights
            dashboard.
          </p>
        )}
        <p className="text-[#00000073]">
          View the{" "}
          <span
            className="text-[#0C98D0] underline cursor-pointer"
            onClick={() => window.open(buildUrl(guide), "_blank")}
          >
            Vivo Guide
          </span>{" "}
          for additional help.
        </p>
        <Button
          data-testid="view-insights-button"
          type="default"
          className="mt-4"
          onClick={() => navigate(buildUrl("insights"))}
        >
          View insights
        </Button>
      </div>

      {/* Footer button action section*/}
      {!isAlertCreated && (
        <div className="flex justify-end mr-2 mb-7">
          <div className="flex items-center justify-between w-full">
            <Button type="text" onClick={onExit} className={`text-[#064C68]`}>
              Exit
            </Button>
            <Button
              type="primary"
              onClick={onAddAlert}
              className="bg-[#0C98D0] text-white"
            >
              Add an alert
            </Button>
          </div>
        </div>
      )}

      {/*Footer notification section */}
      {isAlertCreated && (
        <div className="flex justify-center mb-6">
          <div className="flex bg-[#CAE6D6] text-black p-2 text-xs rounded-md gap-2">
            <CheckCircleFilled className="text-[#387853]" />
            <p>New insight and alert created!</p>
          </div>
        </div>
      )}
    </div>
  );
}
